import { useEffect, useState, useContext } from "react";
import { SocketContext } from "../../context/SocketContext";
import Button from "../../components/Button";
import win_background_img from "../../images/win_background.png"
import red_cat from "../..//images/red_cat.svg";
import win_board_img from "../../images/win_board.png";
import lose_board_1_img from "../../images/lose_board_1.png";
import lose_board_2_img from "../../images/lose_board_2.png";
import lose_board_3_img from "../../images/lose_board_3.png";
import styles from "./styles.module.css";
import win_cat from "../../images/win_cat.svg";
import loose_cat from "../../images/loose_cat.svg";
import Button2 from "../../components/Button/btn2";
import {startGame} from "../Home/index";

const Result = () => {
  const [boardImg, setBoardImg] = useState("");
  const [winner, setWinner] = useState("");
  const { room, player_1 } = useContext(SocketContext);

  useEffect(() => {
    let score = room.players[player_1].score;

    if (score === 3) {
      setBoardImg(win_board_img);
      setWinner(player_1);
    } else if (score === 2) {
      setBoardImg(lose_board_2_img);
      setWinner(player_1 === "player_1" ? "player_2" : "player_1");
    } else if (score === 1) {
      setBoardImg(lose_board_1_img);
      setWinner(player_1 === "player_1" ? "player_2" : "player_1");
    } else {
      setBoardImg(lose_board_3_img);
      setWinner(player_1 === "player_1" ? "player_2" : "player_1");
    }
  }, []);

  return (
    <div className={styles.container}>
      {boardImg === win_board_img && (
        <img
          src={win_background_img}
          alt="win_background_img"
          className={styles.win_background_img}
        />
      )}
      {winner === player_1 ? (
        <>
          <img src={win_cat} alt="black_cat" className={styles.black_cat} />
          <img
            src={red_cat}
            alt="red_cat"
            className={styles.red_cat}
          />
        </>
      ) : (
        <>
          <img
            src={loose_cat}
            alt="black_cat"
            className={styles.black_cat}
          />
          <img src={red_cat} alt="red_cat" className={styles.red_cat} />
        </>
      )}
      <img src={boardImg} alt="boardImg" className={styles.board_img} />
      <div className={styles.btn_container}>
        <Button name="play with friend" type="friend" />
        <Button name="Play with stranger" type="stranger" />
        <Button2 onClick={()=>{startGame()}} name="Play with A.I." />
      </div>
    </div>
  );
};

export default Result;
